import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { map, Observable } from 'rxjs';
import { CandidateDTO } from '$synapse/dtos';
import { PagesHeaderComponent } from '$synapse/core';
import { CandidateDescriptionCardComponent } from './candidate-description-card/candidate-description-card.component';
import { CandidateExamListWidgetComponent } from './candidate-exams-list-widget/candidate-exams-list-widget.component';
import { SHARED_IMPORTS } from '../../core/shared-imports';

@Component({
  selector: 'syn-candidate-details',
  templateUrl: './candidate-details.component.html',
  styleUrls: ['./candidate-details.component.scss'],
  imports: [
    SHARED_IMPORTS,
    PagesHeaderComponent,
    CandidateDescriptionCardComponent,
    CandidateExamListWidgetComponent,
  ],
})
export class CandidateDetailsComponent implements OnInit {
  private readonly _route = inject(ActivatedRoute);

  candidate: CandidateDTO;
  readonly candidate$: Observable<CandidateDTO> = this._route.data.pipe(
    map((data) => data['candidates'])
  );

  ngOnInit(): void {
    this.candidate$.subscribe(() => {});
  }
}
